/**
 * Labstep
 *
 * @module components/ResourceLocation/Action/View
 * @desc Button linking to resource location show
 */

import EntityActionView from 'labstep-web/components/Entity/Action/View';
import { ResourceLocation } from 'labstep-web/models/resource-location.model';
import type React from 'react';
import type { IResourceLocationActionViewProps } from './types';

export const ResourceLocationActionView: React.FC<
  IResourceLocationActionViewProps
> = ({ resourceLocation }) => (
  <EntityActionView
    entityName={ResourceLocation.entityName}
    params={{ id: resourceLocation.guid }}
  />
);
